import React, { useContext, useEffect, useState } from 'react';
import { ModalContext, GlobalContext } from '../../components/contexts';
import GbitTablePaging from '../../components/tableComponents/GbitTablePaging';
import { dbPost } from '../../apis/commonApi';
import { useNavigate, useLocation } from 'react-router-dom';

import SelectEnt from '../../components/selectComponents/SelectEnt';

const SymptomList = () => {
  useEffect(() => {
    document.title = '증상조사표관리';
  }, []);

  const location = useLocation();
  const { modalService } = useContext(ModalContext);
  const { store, updateStore } = useContext(GlobalContext);

  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const [wrkrList, setWrkrList] = useState([]);
  const [formData, setFormData] = useState({
    entSn: store?.entSn,
    entId: store?.userId,
    userType: store?.userType,
    exmnYr: new Date().getFullYear(),
  });
  const [allChecked, setAllChecked] = useState(false);

  const onFormDataChange = (model, value) => {
    setFormData(prev => ({ ...prev, [model]: value }));
  };

  useEffect(() => {
    if (formData.entId !== '') {
      const url = '/member/getUserInfo.do';
      const param = {
        userId: formData.entId.replace(/\s+/g, ''),
        userType: formData.userType,
      };
      dbPost(url, param)
        .then(response => {
          setFormData(prevFormData => ({
            ...prevFormData,
            entSn: response.entSn || '',
            entNm: response.entNm || '',
          }));
        })
        .catch(error => {});
    }
  }, [formData.entId]);

  const getWrkrSurveyList = async () => {
    const url = '/aia/survey/getWrkrSurveyList.do';
    const param = {
      entSn: formData.entSn,
      exmnYr: formData.exmnYr,
      authrtId: store.authrtId,
      userSn: store.userSn,
    };

    dbPost(url, param)
      .then(response => {
        setWrkrList(response);
      })
      .catch(error => {
        modalService.errorAlert(
          '근로자 목록을 가져오는 중 오류가 발생했습니다.'
        );
      });
  };

  useEffect(() => {
    getWrkrSurveyList();
  }, [formData]);

  const naviSurveySymptom = symptomId => {
    if (symptomId == null || symptomId == '') {
      modalService.noticeAlert('작성된 증상조사표가 없습니다.');
    } else {
      navigate(`/ai/surveySymptomResult?symptomId=${symptomId}`);
    }
  };

  useEffect(() => {
    if (formData.entSn != '') {
      getWrkrSurveyList();
    }
  }, [formData.entSn]);

  const paginatedData = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return wrkrList.slice(startIndex, startIndex + itemsPerPage);
  };

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  const [checkedItems, setCheckedItems] = useState([]);

  const handleAllCheck = e => {
    let tempList = [...wrkrList];

    for (let index = 0; index < tempList.length; index++) {
      const temp = tempList[index];
      temp.selected = !allChecked;
    }

    setWrkrList(tempList);
    setAllChecked(!allChecked);
  };

  const handleCheckboxChange = e => {
    const { name, checked } = e.target;

    let tempList = [...wrkrList];

    for (let index = 0; index < tempList.length; index++) {
      const temp = tempList[index];

      if (temp.sn == name) {
        temp.selected = checked;
      }
    }

    setWrkrList(tempList);
  };

  const sendSurvey = async () => {
    let sendList = [];

    for (let index = 0; index < wrkrList.length; index++) {
      const wrkr = wrkrList[index];

      if (wrkr.selected) {
        sendList.push(wrkr);
      }
    }

    if (sendList.length === 0) {
      modalService.noticeAlert('선택된 근로자가 없습니다.');
      return;
    }

    const url = '/aia/survey/sendSurvey.do';
    const param = {
      entSn: formData.entSn,
      exmnYr: formData.exmnYr,
      sendList: sendList,
    };

    let response;

    try {
      response = await dbPost(url, param);
      if (response instanceof Error) {
        modalService.errorAlert('데이터 처리 중 에러가 발생했습니다.');
        return;
      } else {
        modalService.successAlert('증상조사표 발송이 완료되었습니다.');
        getWrkrSurveyList();
      }
    } catch (error) {
      modalService.errorAlert('데이터 처리 중 에러가 발생했습니다.');
      return;
    }
  };

  const reSendSurvey = async wrkr => {
    const url = '/aia/survey/reSendSurvey.do';
    const param = {
      entSn: formData.entSn,
      exmnYr: formData.exmnYr,
      ...wrkr,
    };

    let response;

    try {
      response = await dbPost(url, param);

      if (response instanceof Error) {
        modalService.errorAlert('데이터 처리 중 에러가 발생했습니다. 123');
        return;
      } else {
        modalService.successAlert('증상조사표 발송이 완료되었습니다.');
        getWrkrSurveyList();
      }
    } catch (error) {
      console.log('error', error);
      modalService.errorAlert('데이터 처리 중 에러가 발생했습니다. aaa');
      return;
    }
  };

  const formatPhoneNumber = phoneNumber => {
    if (phoneNumber.length === 11) {
      return phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    }
    return phoneNumber;
  };

  const formatDate = dateStr => {
    if (!dateStr) return '';
    const year = dateStr.slice(0, 2);

    return `20${year}`;
  };

  return (
    <>
      {/* breadcrumb */}
      {/* 페이지 타이틀 영역 */}
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">증상조사표관리</h2>
      </div>
      {/* //페이지 타이틀 영역 */}
      <ul className="guide-txt">
        <li>증상조사표를 관리하는 페이지입니다.</li>
      </ul>
      <div className="tbl-wrap">
        <p className="tbl-msg">
          <em className="star-require">*</em> 표시는 필수 입력 사항입니다.
        </p>
        <table className="tbl data row">
          <colgroup>
            <col style={{ width: '15%' }} />
            <col style={{ width: '35%' }} />
            <col style={{ width: '15%' }} />
            <col style={{ width: '35%' }} />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row">기업명</th>
              <td>
                <div className="input-group">
                  {store.authrtId === 'ADMIN' ? (
                    <SelectEnt
                      model="entSn"
                      valueObj={formData}
                      valueChange={(model, value) => {
                        onFormDataChange(model, value);
                      }}
                    />
                  ) : (
                    <p>{formData.entNm || ''}</p>
                  )}
                </div>
              </td>

              <th scope="row">조사년도</th>
              <td>
                <div className="input-group">
                  <label
                    className="hidden-label"
                    htmlFor="exmnmYr"
                    id="exmnmYrLbl"
                  >
                    조사년도
                  </label>
                  <select
                    id="exmnmYr"
                    className="form-select md"
                    value={formData?.exmnYr}
                    onChange={e => onFormDataChange('exmnYr', e.target.value)}
                    aria-labelledby="exmnmYrLbl"
                  >
                    <option value="">선택</option>
                    {Array.from(
                      { length: new Date().getFullYear() - 2024 + 2 },
                      (_, i) => 2024 + i
                    ).map(year => (
                      <option key={year} value={year}>
                        {year}년
                      </option>
                    ))}
                  </select>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* table list */}
      <div className="tbl-wrap">
        <h3 className="block-tit">근로자 목록</h3>
        <table className="tbl col data scroll">
          <colgroup>
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th scope="col">
                <div className="form-check">
                  <input
                    type="checkbox"
                    name="chk_all"
                    id="chk_all"
                    onChange={handleAllCheck}
                    checked={allChecked}
                  />
                  <label htmlFor="chk_all">
                    <span className="sr-only">전체선택</span>
                  </label>
                </div>
              </th>
              <th scope="col">성명</th>
              <th scope="col">직책</th>
              <th scope="col">연락처</th>
              <th scope="col">부서</th>
              <th scope="col">조사년도</th>
              <th scope="col">응답여부</th>
              <th scope="col">응답시간</th>
              <th scope="col">발송여부</th>
              <th scope="col">발송시간</th>
              <th scope="col">재전송</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData().map((wrkrList, index) => (
              <tr key={index}>
                <td>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      name={wrkrList.sn}
                      id={wrkrList.sn + index}
                      checked={wrkrList.selected ?? false}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor={wrkrList.sn + index}>
                      <span className="sr-only">선택</span>
                    </label>
                  </div>
                </td>
                <td>
                  <strong>{wrkrList.nm}</strong>
                </td>
                <td>{wrkrList.role}</td>
                <td>{formatPhoneNumber(wrkrList.mblTelno)}</td>

                <td>{wrkrList.dept}</td>
                <td>
                  {wrkrList.sndngDt != null ? (
                    <span>{formatDate(wrkrList.sndngDt)}</span>
                  ) : (
                    <span>-</span>
                  )}
                </td>
                <td>
                  {wrkrList.userRplYn == 'Y' ? (
                    <button
                      className="krds-badge bg1"
                      onClick={() => {
                        naviSurveySymptom(wrkrList.symptomId);
                      }}
                    >
                      응답
                    </button>
                  ) : (
                    <span className="krds-badge bg2">미응답</span>
                  )}
                </td>
                <td>{wrkrList.userRplDt != null ? wrkrList.userRplDt : '-'}</td>
                <td>
                  {wrkrList.sndngYn == 'Y' ? (
                    <span className="krds-badge bg1">발송</span>
                  ) : (
                    <span className="krds-badge bg2">미발송</span>
                  )}
                </td>
                <td>{wrkrList.sndngDt != null ? wrkrList.sndngDt : '-'}</td>
                <td>
                  {wrkrList.sndngYn == 'Y' ? (
                    <button
                      className="krds-badge bg1"
                      onClick={() => {
                        reSendSurvey(wrkrList);
                      }}
                    >
                      재전송
                    </button>
                  ) : (
                    <span className="krds-badge bg2">재전송</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <GbitTablePaging
        totalItems={wrkrList.length}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />
      {/* //paging : 웹 */}
      <div className="page-btn-wrap both">
        <div className="btn-wrap"></div>
        <div className="btn-wrap">
          <button
            type="button"
            className="btn xlg primary"
            onClick={() => {
              sendSurvey();
            }}
            disabled={store?.authrtId === 'MU'}
          >
            증상조사표 발송
          </button>
        </div>
      </div>
    </>
  );
};

export default SymptomList;
